import {
  init_react_import
} from "./chunk-65BGW52G.mjs";

// variables/transitions.ts
init_react_import();
var TransitionDuration;
(function(TransitionDuration2) {
  TransitionDuration2["Fast"] = "200ms";
  TransitionDuration2["Medium"] = "400ms";
})(TransitionDuration || (TransitionDuration = {}));

export {
  TransitionDuration
};
//# sourceMappingURL=chunk-BRFMOBZJ.mjs.map